import {createBrowserRouter} from "react-router-dom";
import {ROUTES} from "../utils/consts/router";
import {Error404} from "../App";
import Home from "../views/Home";

function DashboardRouter() {

  return createBrowserRouter([
    {
      path: ROUTES.HOME,
      element: <Home/>,
      errorElement: <Error404/>,
    }
  ])
}

export const dashboardRouter = DashboardRouter();